export const reOrgConstants = {
	GetMinOrgByNameOrUNP: {
		FAILURE : 'GET_MIN_ORG_BY_NAME_OR_UNP_FAILURE',
		REQUEST : 'GET_MIN_ORG_BY_NAME_OR_UNP_REQUEST',
		SUCCESS : 'GET_MIN_ORG_BY_NAME_OR_UNP_SUCCESS'
	},
	GetPaged: {
		FAILURE : 'GET_PAGED_RE_ORG_FAILURE',
		REQUEST : 'GET_PAGED_RE_ORG_REQUEST',
		SUCCESS : 'GET_PAGED_RE_ORG_SUCCESS'
	},
	Create: {
		FAILURE : 'CREATE_RE_ORG_FAILURE',
		REQUEST : 'CREATE_RE_ORG_REQUEST',
		SUCCESS : 'CREATE_RE_ORG_SUCCESS'
	},
	Update: {
		FAILURE : 'UPDATE_RE_ORG_FAILURE',
		REQUEST : 'UPDATE_RE_ORG_REQUEST',
		SUCCESS : 'UPDATE_RE_ORG_SUCCESS'
	},
	Delete: {
		FAILURE : 'DELETE_RE_ORG_FAILURE',
		REQUEST : 'DELETE_RE_ORG_REQUEST',
		SUCCESS : 'DELETE_RE_ORG_SUCCESS'
	},
	GetReOrgInfo: {
		SUCCESS : 'GET_RE_ORG_INFO_SUCCESS',
		REQUEST : 'GET_RE_ORG_INFO_REQUEST',
		FAILURE : 'GET_RE_ORG_INFO_FAILURE'
	},
	UpdateReOrgInfo: {
		SUCCESS : 'UPDATE_RE_ORG_INFO_SUCCESS',
		REQUEST : 'UPDATE_RE_ORG_INFO_REQUEST',
		FAILURE : 'UPDATE_RE_ORG_INFO_FAILURE'
	},
	CLEAR: 'CLEAR_RE_ORG'
}